// components/mypage/MyPageLayout.tsx
import { ReactNode } from "react";
import MyPageNav from "./MyPageNav";

interface MyPageLayoutProps {
  title: string;
  children: ReactNode;
}

export default function MyPageLayout({ title, children }: MyPageLayoutProps) {
  return (
    <div className="min-h-screen bg-[#fafafa]">

      {/* 모바일: 상단 탭 네비게이션 */}
      <div className="md:hidden">
        <MyPageNav variant="tabs" />
      </div>

      {/* 공통 콘텐츠 */}
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-6 md:py-12">
        <div className="mb-5 md:mb-8">
          <h1 className="text-[22px] md:text-[26px] font-extrabold text-[#5a4035] mb-2">{title}</h1>
        </div>

        <div className="md:flex md:gap-7 md:items-start">
          {/* 데스크탑 전용 사이드바 */}
          <div className="hidden md:block">
            <MyPageNav variant="sidebar" />
          </div>
          <main className="flex-1 min-w-0">{children}</main>
        </div>
      </div>

    </div>
  );
}
